// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1iI5w","container":"styles_container__21aC4","title":"styles_title__bFHcB","wrapper":"styles_wrapper__1F1n_","answer":"styles_answer__2QhpZ"};